import { pictogramsAtom } from 'atoms'
import { NoUsedTags } from 'constants'
import { useAtomValue } from 'jotai'
import { Box, Chip } from '@mui/material'

const Intersection = ({ uuid: id, currentIndex }) => {
  const allPictograms = useAtomValue(pictogramsAtom)
  const item = allPictograms[id]
  const ownTags = ['noun', 'adjective', 'verb'].includes(item.wordType)
    ? item?.pictos[currentIndex]?.tags || []
    : []
  const commonTags = Object.entries(allPictograms).reduce(
    (acc, [uuid, pictogram]) => {
      if (uuid !== id) {
        const tags = pictogram.pictos.map((picto) => picto.tags).flat()
        const common = tags
          .filter((tag) => ownTags.includes(tag))
          .filter((tag) => !NoUsedTags.includes(tag)) // Exclude NoUsedTags

        // Add all common tags to the Set
        acc = new Set([...acc, ...common])
      }
      return acc
    },
    new Set()
  )

  // Convert Set to Array
  const uniqueCommonTags = Array.from(commonTags)

  return (
    <Box sx={{ marginTop: 1 }} display="flex" flexWrap="wrap" gap={1}>
      {uniqueCommonTags.map((tag) => (
        <Chip key={tag} label={tag} />
      ))}
    </Box>
  )
}

export default Intersection
